<template>
  <div id="app">
    <div class="navigation">
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <router-link to="/" >
          <img class="mr-1 img mb-2" src="./assets/logo.svg" height="30" />
          <div class="navbar-brand title-font">data ping pong</div>
        </router-link>

        <b-navbar-toggle id="navbar-swicth" target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item>
              <router-link to="/" class="text-light">
                <font-awesome-icon icon="home"/>
                ホーム
              </router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link to="/analyze" class="text-light">
                <font-awesome-icon icon="chart-bar"/>
                分析
              </router-link>
            </b-nav-item>
            <b-nav-item v-if="user.signIn">
              <router-link to="/data_page" class="text-light">
                <font-awesome-icon icon="history"/>
                マイデータ
              </router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link to="/public_data" class="text-light">
                <font-awesome-icon icon="list"/>
                みんなの分析
              </router-link>
            </b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item v-if="user.signIn">
              <router-link to="/user" class="text-light"><font-awesome-icon icon="user"/>
                設定
              </router-link>
            </b-nav-item>
            <b-nav-form>
              <b-button size="sm" class="my-2 my-sm-0" v-b-modal.modal-signin
                v-if="!user.signIn" @click="toggleClick();">
                ログイン
              </b-button>
              <b-button size="sm" class="my-2 my-sm-0" @click="signOut();toggleClick();"
                v-if="user.signIn">
                ログアウト
              </b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <transition mode="out-in">
    <!-- routerでの表示切り替え部分 -->
    <router-view />
    </transition>

    <!-- ログインモーダル -->
    <b-modal id="modal-signin" centered title="ログイン"  hide-footer v-if="!user.signIn">
      <div class="contaier text-center">
        <div v-if="isGoogle">
          <b-button @click="signUpWithGoogle()" variant="danger" class="btn-google text-white mt-3">
            <span class="float-left"><font-awesome-icon :icon='["fab", "google"]' />
              Googleアカウントでログインする
            </span>
          </b-button>
          <p class="mt-4">
            <b-button variant="outline-secondary" class="btn-sm" @click="isGoogle = !isGoogle">
              メールアドレスでログインする
            </b-button>
          </p>
        </div>
        <div v-else>
          <b-form-input type="text" placeholder="メールアドレス" v-model="username" />
          <b-form-input type="password" placeholder="パスワード" v-model="password" />
          <b-button variant="primary" class="mt-4 btn-block" @click="signIn()">ログイン</b-button>
          <p class="mt-4" @click="$bvModal.hide('modal-signin')">
            <router-link to="/signup">メールアドレスを登録する</router-link>
          </p>
          <p class="mt-3" @click="$bvModal.hide('modal-signin')">
            <router-link to="/forget_password">パスワードを忘れた方はこちら</router-link>
          </p>
          <p class="mt-3">
            <b-button variant="outline-secondary" class="btn-sm" @click="isGoogle = !isGoogle">
              Googleアカウントでログインする
            </b-button>
          </p>
        </div>
      </div>
    </b-modal>

    <!-- loading モーダル-->
    <b-modal id="modal-loading" size="sm" centered hide-header hide-footer
      :no-close-on-backdrop="true" :no-close-on-esc="true">
      <div class="text-center">
        loading...
      <div class="loader">...</div>
      </div>
    </b-modal>

    <div class="mt-5 bg-dark">
      <div class="container-fluid bg-dark text-white text-center pt-5 pb-5 mt-5">
        <p class="mr-2"><router-link to="/question">
          <a class="text-white">お問い合わせ</a>
        </router-link></p>
        <p class="mr-2">
          <a class="text-white" href="./privacy_policy.html">プライバシーポリシー</a>
        </p>
        <p class="mr-2">
          <a class="text-white" href="./term.html">利用規約</a>
        </p>
        <p class="title-font">©data ping pong</p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import { mapActions, mapGetters } from 'vuex';
import Analyze from '@/views/Analyze';
import Home from '@/views/Home';

export default {
  name: 'app',
  components: {
    Analyze,
    Home,
  },
  data() {
    return {
      username: '',
      password: '',
      passwordConf: '',
      isGoogle: true,
      message: '',
    };
  },
  mounted() {
    if (this.user.redirect) {
      this.SignInGoogle();
    }
  },
  computed: {
    isLoadingCmp() {
      return this.app.loading;
    },
    ...mapGetters([
      'user',
      'app',
    ]),
  },
  methods: {
    ...mapActions([
      'SignOut',
      'SignInMail',
      'SignInGoogle',
      'setRedirect',
    ]),
    signOut() {
      const conf = confirm('ログアウトします。よろしいですか？');
      if (conf) {
        firebase.auth().signOut().then(() => {
          this.SignOut();
          this.$router.push('/');
        });
      }
    },
    signIn() {
      this.SignInMail({ username: this.username, password: this.password });
      this.password = '';
    },
    signUpWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider);
      this.setRedirect(true);
    },
    toggleClick() {
      document.getElementById('navbar-swicth').click();
    },
  },
  watch: {
    isLoadingCmp(val) {
      if (val) {
        this.$bvModal.show('modal-loading');
      } else {
        this.$bvModal.hide('modal-loading');
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Orbitron&display=swap");

.v-enter-active, .v-leave-active {
  transition: opacity .2s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}

</style>

<style>

.btn-google{
  background-color:#D34836;
  border-color:#D34836;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont,
    "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3",
    Hiragino Kaku Gothic ProN, Arial, "メイリオ", Meiryo, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top:0px;
  background-color:#F5F5F5;
}

.title-font{
  font-family: 'Orbitron', sans-serif;
}

.a {
  text-decoration: none;
}
.loader,
.loader:before,
.loader:after {
  background: #373636;
  -webkit-animation: load1 1s infinite ease-in-out;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 1em;
}
.loader {
  color: #373636;
  text-indent: -9999em;
  margin: 88px auto;
  position: relative;
  font-size: 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  position: absolute;
  top: 0;
  content: '';
}
.loader:before {
  left: -1.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 1.5em;
}
@-webkit-keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 2em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 3em;
  }
}
@keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 2em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 3em;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue